var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeNoahBirthday(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 320 568",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #77af64;\n      }\n\n      .cls-2 {\n        fill: #fff;\n      }\n\n      .cls-3 {\n        fill: #dbdbdb;\n      }\n\n      .cls-4 {\n        fill: #94de7e;\n      }\n\n      .cls-5 {\n        fill: #a6a6a6;\n      }\n\n      .cls-6 {\n        fill: #c7c7c7;\n      }\n\n      .cls-7 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-8 {\n        fill: #ebebeb;\n      }\n\n      .cls-9 {\n        fill: none;\n      }\n\n      .cls-10 {\n        isolation: isolate;\n        opacity: .1;\n      }\n\n      .cls-11 {\n        fill: #7329e8;\n      }\n\n      .cls-12 {\n        fill: #fed234;\n      }\n\n      .cls-13 {\n        fill: #aa4859;\n      }\n\n      .cls-14 {\n        fill: #263238;\n      }\n\n      .cls-15 {\n        fill: #442491;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    width: 320,
    height: 568
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4",
    "data-name": "Layer 4"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: -103.24,
    y: -43.84,
    width: 587.71,
    height: 628.4
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m92.07,344.39l-17.49.36-8.88.16c-2.97,0-5.96,0-8.93.07h-.59v-.59l-.08-14.91v-.68h.67l17.65.08c5.89,0,11.77.15,17.65.21h.37v.36c0,2.52-.12,5.04-.17,7.53l-.2,7.41Zm0,0l-.19-7.54c0-2.48-.15-4.93-.17-7.37l.36.36c-5.88.07-11.76.21-17.65.21l-17.65.08.67-.65v14.91l-.6-.6c2.91,0,5.81,0,8.73.07l8.77.16,17.73.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m72.39,363.21l-17.49.36-8.88.16c-2.97,0-5.96,0-8.93.07h-.59v-.59l-.08-14.9v-.68h.67l17.65.08c5.88,0,11.77.15,17.65.21h.37v.36c0,2.52-.11,5.04-.17,7.53l-.2,7.4Zm0,0l-.19-7.54c-.07-2.48-.15-4.93-.17-7.37l.36.36c-5.88.07-11.77.21-17.65.21l-17.65.08.67-.65-.07,14.91-.6-.59h8.73l8.77.16,17.79.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m218.09,76.01l-17.49.36-8.88.16c-2.97,0-5.96,0-8.93.07h-.59v-.59l-.08-14.91v-.68h.67l17.65.08c5.89,0,11.77.15,17.65.21h.37v.36c0,2.52-.12,5.04-.17,7.53l-.2,7.41Zm0,0l-.19-7.54c0-2.48-.15-4.93-.17-7.37l.36.36c-5.88.07-11.76.21-17.65.21l-17.65.08.67-.65v14.91l-.6-.6c2.91,0,5.81,0,8.73.07l8.77.16,17.73.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m198.4,94.83l-17.49.36-8.88.16c-2.97,0-5.96,0-8.93.07h-.59v-.59l-.08-14.9v-.68h.67l17.65.08c5.88,0,11.77.15,17.65.21h.37v.36c0,2.52-.11,5.04-.17,7.53l-.2,7.4Zm0,0l-.19-7.54c-.07-2.48-.15-4.93-.17-7.37l.36.36c-5.88.07-11.77.21-17.65.21l-17.65.08.67-.65-.07,14.91-.6-.59h8.73l8.77.16,17.79.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m112.73,44.7l-17.5.37-8.88.15c-2.96,0-5.94,0-8.92.08h-.6v-.6l-.07-14.91v-.67h.67l17.65.08c5.88,0,11.77.16,17.65.23h.36v.36c0,2.53-.11,5.05-.17,7.53l-.19,7.38Zm0,0l-.19-7.53c0-2.49-.16-4.94-.17-7.38l.36.36c-5.88,0-11.77.21-17.65.23l-17.65.08.67-.67-.08,14.91-.59-.6c2.91,0,5.81,0,8.72.08l8.77.15,17.81.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m290.96,28.52l-17.5.37-8.88.15c-2.96,0-5.94,0-8.92.08h-.6v-.6l-.07-14.91v-.67h.67l17.65.08c5.88,0,11.77.16,17.65.23h.36v.36c0,2.53-.11,5.05-.17,7.53l-.19,7.38Zm0,0l-.19-7.53c0-2.49-.16-4.94-.17-7.38l.36.36c-5.88,0-11.77.21-17.65.23l-17.65.08.67-.67-.08,14.91-.59-.6c2.91,0,5.81,0,8.72.08l8.77.15,17.81.37Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 30.72,
    y: 183.37,
    width: 57.95,
    height: 70.29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 37.34,
    y: 189.79,
    width: 44.7,
    height: 57.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 37.34,
    y: 189.79,
    width: 1.75,
    height: 57.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 88.67,
    y: 183.37,
    width: 1.75,
    height: 70.29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 52.32,
    y: 197.72,
    width: 10.53,
    height: 31.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m76.4,235.05h-29.25v-16.52h29.25v16.52Zm-28.11-1.13h26.98v-14.25h-26.98v14.25Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 111.58,
    y: 110.81,
    width: 168.95,
    height: 215.41
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 120.73,
    y: 119.44,
    width: 71.42,
    height: 95.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 199.96,
    y: 119.44,
    width: 71.42,
    height: 95.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 120.73,
    y: 221.79,
    width: 71.42,
    height: 95.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 199.96,
    y: 221.79,
    width: 71.42,
    height: 95.81
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "215.35 110.81 280.52 110.81 280.52 418.99 242.8 418.99 269.13 262.18 215.35 110.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "226.64 119.14 237.53 154.82 248.26 190.56 269.69 262.01 269.72 262.14 269.71 262.25 259.58 337 254.52 374.37 249.27 411.7 253.95 374.29 258.82 336.89 268.56 262.1 268.59 262.35 247.52 190.77 237 154.98 226.64 119.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "276.65 125.47 276.93 156.37 277.09 187.28 277.23 249.09 277.09 310.91 276.93 341.82 276.65 372.72 276.36 341.82 276.2 310.91 276.07 249.09 276.21 187.28 276.36 156.37 276.65 125.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "264.47 131.26 267.05 164.08 269.51 196.9 274.28 262.57 274.28 262.6 274.28 262.62 271.88 335.81 270.57 372.4 269.13 408.98 269.99 372.39 270.96 335.78 273.14 262.59 273.14 262.65 268.66 196.97 266.51 164.11 264.47 131.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m255.99,404.24l3.63-35.52,3.77-35.51c2.61-23.65,5.11-47.33,7.81-70.97v.15l-11.79-55.29-5.79-27.66-5.72-27.67,6.2,27.57,6.12,27.6,12.07,55.22v.23c-2.56,23.66-5.31,47.3-7.95,70.97l-4.11,35.46-4.23,35.41Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 265.81,
    y: 259.6,
    width: 14.72,
    height: 7.18
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "176.9 110.81 111.73 110.81 111.73 418.99 149.45 418.99 123.12 262.18 176.9 110.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "165.62 119.14 155.26 154.98 144.73 190.77 123.68 262.35 123.69 262.1 133.43 336.89 138.31 374.29 143 411.7 137.75 374.37 132.67 337 122.55 262.25 122.53 262.14 122.57 262.01 144 190.56 154.72 154.82 165.62 119.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "115.61 125.47 115.89 156.37 116.05 187.28 116.19 249.09 116.05 310.91 115.89 341.82 115.61 372.72 115.32 341.82 115.16 310.91 115.03 249.09 115.16 187.28 115.32 156.37 115.61 125.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "127.78 131.26 125.74 164.11 123.6 196.97 119.12 262.65 119.12 262.59 121.3 335.78 122.28 372.39 123.12 408.98 121.68 372.4 120.38 335.81 117.99 262.62 117.99 262.6 117.99 262.57 122.74 196.9 125.21 164.08 127.78 131.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m136.27,404.24l-4.25-35.45-4.11-35.46c-2.64-23.66-5.39-47.3-7.94-70.97v-.17l12.07-55.22,6.07-27.6,6.2-27.57-5.71,27.67-5.79,27.66-11.76,55.26v-.17c2.7,23.64,5.2,47.31,7.82,70.97l3.75,35.51,3.65,35.54Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 111.73,
    y: 259.59,
    width: 14.72,
    height: 7.18
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m9.91,479.5c103.17-.75,213.47-1.09,316.55-.11,0,0,0,.68,0,.68-75.58.86-161.5.73-237.41.55-19.67-.06-59.46-.28-79.14-.44,0,0,0-.68,0-.68h0Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m158.46,358.71s-17-2.38-13.03-22.91c0,0,19,4.27,13.03,22.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m158.46,358.71s-17-2.38-13.03-22.91c0,0,19,4.27,13.03,22.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m157.6,354.43c-.33-1.04-.73-2.06-1.16-3.06l-.05-.39-.07-.85c-.05-.61-.08-1.22-.12-1.83-.07-1.23-.15-2.45-.17-3.68-.01-.03-.04-.04-.07-.03-.01,0-.03.02-.03.03v3.68c0,.62.06,1.23.1,1.84v.4c-.95-2.04-2.09-3.99-3.41-5.83-.58-.83-1.2-1.62-1.87-2.38-.67-.79-1.39-1.52-2.08-2.28-.04-.06-.11,0-.07.07,1.22,1.35,2.32,2.81,3.28,4.36.52.79,1.01,1.59,1.47,2.38l-.16-.06c-.2-.08-.4-.17-.6-.24l-1.39-.53c-.91-.33-1.83-.67-2.73-1.02-.06,0-.1.08-.04.1.9.37,1.79.75,2.69,1.13l1.32.57.67.27c.14.07.29.12.44.16.35.62.68,1.24,1,1.87.79,1.59,1.48,3.23,2.07,4.9.05.12.09.24.13.35-.45-.26-.91-.48-1.4-.67l-1.75-.79c-1.19-.55-2.38-1.1-3.52-1.75-.06-.04-.1.06-.05.09,1.17.64,2.31,1.32,3.48,1.95.59.32,1.17.63,1.77.91.49.29,1.03.51,1.59.64.57,1.56.95,3.18,1.12,4.83.19,2.32.17,4.66.22,6.99,0,.04.06,0,.06,0,.17-2.11.27-4.25.28-6.35,0-1.96-.33-3.91-.94-5.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m154.98,342.36c-.17,1.2-.22,2.41-.17,3.62m.05,0c.07-1.21.08-2.38.22-3.6,0-.06-.1-.1-.1-.02l-.12,3.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m150.11,343.38c-.76-.29-1.49-.65-2.18-1.07-.06,0-.1.06-.05.09.68.46,1.42.82,2.21,1.06,0,0,.07-.06.02-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m158.99,391.29c0-1.88-.05-3.75-.07-5.64,0-6.24-.09-12.48-.2-18.72-.09-4.95-.2-9.91-.34-14.86-.21-7.43,0-.05-.05-.06v-4.06s0-.06-.09-.05-.08,0-.08.05v4.06s-.04.04-.04.06c-.25,8.81-.48,17.63-.52,26.45v5.37c-.06,5.76-.09,11.51-.07,17.25v2.75c0,5.26.06,10.52.06,15.78,0,.28.32.42.65.44s.79-.13.79-.46c0-5.8.04-11.61.04-17.4-.06-3.66-.05-7.31-.08-10.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m151.9,385.59s-8.18-6.06-15.94-1.97c-7.76,4.09-8.98,19.85-8.98,19.85,0,0,11.39,1.64,18.58-5.2,6.91-6.53,6.34-12.68,6.34-12.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m151.9,385.59s-8.18-6.06-15.94-1.97c-7.76,4.09-8.98,19.85-8.98,19.85,0,0,11.39,1.64,18.58-5.2,6.91-6.53,6.34-12.68,6.34-12.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m154.13,385.96c-1.51-.6-3.15-.81-4.76-.62-.33-.06-.66-.09-1-.1l-1.16-.09c-.79-.06-1.59-.11-2.38-.17-1.59-.12-3.23-.22-4.84-.38-.06,0-.07.1,0,.1,1.59.2,3.18.43,4.76.59.79.09,1.64.17,2.47.23.19,0,.39,0,.6.06-.25.06-.49.11-.73.18-1.28.37-2.52.87-3.7,1.5-.65.12-1.29.3-1.92.44-1.01.24-2.02.5-3.02.79-1.98.52-3.97,1.1-5.92,1.67-.06,0,0,.12,0,.1,1.97-.48,3.97-.93,5.92-1.4.96-.23,1.92-.45,2.87-.69l.75-.17c-2.2,1.36-4.16,3.07-5.81,5.06-1.6,1.95-2.95,4.08-4.04,6.35,0,.06.05.12.09.06,1.34-2.35,2.99-4.5,4.89-6.42-.04.11-.07.22-.11.33l-.45,1.44c-.3.97-.61,1.93-.9,2.9,0,.06.08.09.1,0,.34-.94.67-1.87,1-2.81.16-.46.32-.92.48-1.38.08-.24.17-.48.25-.72l.08-.21c.91-.89,1.88-1.72,2.9-2.48,1.35-.99,2.81-1.82,4.34-2.48,0,.14-.06.29-.08.42-.09.37-.17.74-.25,1.11-.16.79-.31,1.59-.46,2.33-.31,1.59-.5,3.18-.79,4.76.01.03.04.04.07.03.01,0,.03-.02.03-.03.37-1.59.83-3.18,1.19-4.76.17-.79.36-1.59.52-2.38.08-.37.15-.75.23-1.12.04-.21.09-.42.11-.63l.44-.18c2.14-.92,4.49-1.24,6.8-.94,2.2.41,4.05,1.9,4.92,3.97.08.17.36.06.32-.11-.55-1.91-1.96-3.45-3.82-4.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m141.6,392.7c-.23,1.04-.46,2.07-.68,3.11-.26.99-.45,2-.57,3.02,0,.04.05.04.06,0,.3-1,.53-2.02.69-3.05.21-1.02.4-2.05.6-3.07.02-.06-.09-.08-.1-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m133.7,395.33c-1.04.52-2.05,1.13-3.14,1.59-.02.01-.03.04-.02.06.01.02.04.03.06.02,1.07-.47,2.11-1,3.12-1.59,0,0,0-.1-.02-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m153.73,374.46s-9.99.64-14.64-5.95-3.61-16-3.61-16c0,0,10.5,1.28,14.67,6.01,4.17,4.73,3.58,15.95,3.58,15.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m158.42,384.32c-.34-1.07-.79-2.13-1.17-3.18s-.79-2-1.25-2.99c-.89-2.01-1.89-3.98-2.99-5.89-.71-1.21-1.46-2.38-2.24-3.56,0-.17-.06-.35-.08-.53l-.14-.93c-.1-.63-.21-1.26-.31-1.89-.23-1.38-.52-2.75-.74-4.14,0-.06-.11-.06-.1,0,.2,1.37.34,2.74.53,4.1.1.67.18,1.34.28,2.01l.12.73c-1.53-2.23-3.18-4.37-4.95-6.41-.24-.28-.48-.55-.73-.79,0-.08-.06-.15-.1-.23l-.21-.57c-.15-.4-.29-.79-.44-1.19-.28-.79-.53-1.59-.74-2.38-.01-.03-.04-.04-.07-.03-.01,0-.03.02-.03.03.2.79.41,1.64.66,2.45.11.39.24.79.38,1.16l.07.19c-1.28-1.39-2.61-2.73-3.97-4.06-.02-.02-.05-.02-.07,0s-.02.05,0,.07c2.58,2.7,4.95,5.6,7.08,8.68-.24-.08-.49-.14-.74-.18-.79-.15-1.54-.26-2.32-.36-1.64-.21-3.25-.41-4.87-.67-.07,0-.1.09,0,.1,1.59.31,3.09.65,4.63,1.01.72.17,1.45.31,2.18.45.59.13,1.18.3,1.75.5l.48.69c.74,1.06,1.45,2.14,2.13,3.25l-1.02-.2c-.79-.15-1.55-.29-2.33-.41-1.52-.25-3.05-.52-4.56-.87-.06,0-.09.09,0,.1,1.53.36,3.04.79,4.56,1.18.73.19,1.47.37,2.21.53l1.11.25c.15.04.29.06.44.07,1.46,2.38,2.83,4.8,4.1,7.26.56,1.09,1.1,2.19,1.59,3.29s.99,2.29,1.48,3.45c.08.23.44.16.36-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m148.2,361.35c-.19-.95-.4-1.91-.6-2.86,0-.06-.12,0-.1,0,.19.94.37,1.87.54,2.82.14.94.33,1.87.57,2.79h0c-.07-.93-.2-1.85-.4-2.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m142.36,361.07c-.46-.23-.95-.42-1.44-.61l-.75-.29-.39-.15c-.15-.05-.29-.11-.42-.19-.08-.06-.13.08-.05.09.15.04.29.1.43.17l.37.17.73.33c.48.22.97.42,1.48.58.03,0,.06-.02.06-.05,0-.02,0-.03-.02-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m163.96,366.6s6.05-11.3,15.26-13.05c9.21-1.75,14.84,7.72,14.84,7.72,0,0-6.72,8.57-15.16,10.07s-14.93-4.74-14.93-4.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m185.39,358.61c-2.4-.32-4.83-.29-7.22.09l.41-.22c.68-.34,1.37-.7,2.04-1.05,1.41-.74,2.84-1.52,4.33-2.11.03-.01.04-.04.03-.07-.01-.03-.04-.04-.07-.03,0,0,0,0-.01,0-1.44.67-2.93,1.23-4.37,1.9-.72.33-1.43.67-2.14,1.05-.45.25-.95.47-1.41.79-2.02.41-3.98,1.06-5.84,1.94l1.14-1.25c.87-.94,1.71-1.93,2.65-2.79.05-.04,0-.11-.08-.07-.96.87-1.98,1.68-2.91,2.6-.45.44-.89.9-1.31,1.37-.21.24-.42.48-.62.73-6.4,3.43-10.93,9.55-12.34,16.67.01.03.04.04.07.03.01,0,.03-.02.03-.03,1.29-4.31,3.62-8.23,6.76-11.45,3.38-3.46,7.65-5.93,12.33-7.14,2.78-.71,5.65-.98,8.51-.79.05-.02.07-.08.05-.13,0-.01-.01-.02-.02-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m194.06,361.27s-6.72,8.57-15.16,10.07c-6.45,1.14-11.74-2.21-13.89-3.87l-.47-.79s4.36-3.68,12.6-5.79,16.92.39,16.92.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m180.04,354.59c-.71.41-1.39.86-2.04,1.35-.64.47-1.24,1-1.78,1.59-.05.06,0,.12.08.08.61-.53,1.23-1.06,1.86-1.59.62-.51,1.26-.97,1.94-1.4.03,0,.05-.03.05-.06,0-.03-.03-.05-.06-.05s-.05.03-.05.06c0,0,0,.01,0,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m185.1,356.5c-.34.13-.69.26-1.03.4l-1.02.42c-.07,0-.04.15,0,.12l1.03-.41,1.02-.44c.1-.02.06-.13,0-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m162.76,380.82s1.59,11.22,10.05,15.13,18.7,0,18.7,0c0,0-4.04-24.25-28.75-15.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m162.76,380.82s1.59,11.22,10.05,15.13,18.7,0,18.7,0c0,0-4.04-24.25-28.75-15.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m185.68,388.66c-.79-.09-1.55-.22-2.32-.37-.38-.06-.79-.13-1.14-.21l-.59-.11-.68-.64c-1.6-1.4-3.33-2.66-5.16-3.74-1-.59-2.03-1.12-3.09-1.59h.16l2.78.12c1.85.09,3.7.13,5.56.25.06,0,.06-.1,0-.1-1.85-.13-3.7-.33-5.56-.48l-2.7-.25-1.39-.12h-.36c-.48-.17-.96-.35-1.45-.5-2.3-.79-4.77-.93-7.14-.39-2.12.54-4.24,1.93-4.76,4.17,0,.07.1.13.13.05.79-1.87,2.87-2.8,4.76-3.18,1.26-.24,2.55-.27,3.82-.08.09.58.23,1.15.43,1.7.23.79.46,1.59.7,2.38.48,1.59,1.01,3.13,1.47,4.71.01.03.04.04.07.03.01,0,.03-.02.03-.03-.39-1.59-.72-3.18-1.1-4.76-.18-.79-.38-1.59-.57-2.32-.11-.54-.25-1.07-.42-1.59.74.13,1.47.3,2.18.52,1.3.38,2.58.85,3.82,1.4.13.79.3,1.59.49,2.38.23.98.48,1.97.79,2.94,0,.03.02.05.05.05.03,0,.05-.02.05-.05v-.18h0c-.18-.92-.39-1.83-.58-2.75-.16-.74-.3-1.48-.46-2.21,1.05.47,2.07.98,3.07,1.59.02.22.06.45.11.67.06.38.13.79.2,1.15.16.87.33,1.72.54,2.58.38,1.65.86,3.28,1.44,4.87v.06l.05.06s.1,0,.09-.05c-.39-1.66-.83-3.31-1.2-4.98-.18-.79-.37-1.67-.53-2.5-.09-.42-.16-.83-.24-1.25,0-.12-.04-.25-.06-.37,1.13.67,2.23,1.4,3.29,2.18,1.82,1.37,3.5,2.9,5.02,4.59.06.07.17,0,.12-.1-.63-.85-1.3-1.67-2.01-2.45-.42-.45-.87-.9-1.31-1.33h.13c.4.07.79.13,1.19.18.79.1,1.59.17,2.34.27-.02-.1.02-.21-.07-.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m179.78,392.46h0l-.05-.29c0-.13-.09-.24-.1-.37h0c-.17-.75-.32-1.5-.45-2.25,0-.03-.02-.05-.05-.05-.03,0-.05.02-.05.05.05,1,.27,1.99.64,2.93,0,0,.06,0,.06,0v-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m172.72,392.28s-.02-.05-.05-.05c-.24-.99-.46-1.98-.67-2.98-.11-.52-.22-1.05-.32-1.59-.06-.28-.11-.56-.16-.85-.02-.25-.08-.5-.18-.73-.02-.03-.05-.03-.08-.02,0,0-.01.01-.02.02,0,.51.07,1.02.21,1.51.1.55.21,1.09.33,1.64.25,1.1.52,2.21.83,3.29.01.03.05.05.08.04.02,0,.03-.02.04-.04l-.02-.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m184.94,385.43c-1.54-.21-3.08-.43-4.62-.62-.07,0-.1.1,0,.1,1.54.22,3.08.41,4.62.62.04,0,.06-.1,0-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m158.44,354.53s-5.15-22.63,19.15-31.75c0-.03,6.74,29.75-19.15,31.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m163.69,341.73l.26-.16c.46-.25.92-.51,1.37-.79l2.83-1.59c1.85-1.04,3.68-2.12,5.56-3.14.06,0,0-.12-.05-.09-1.87,1.02-3.78,1.97-5.66,2.97l-2.79,1.47-1.14.6c.79-1.54,1.68-3.05,2.63-4.5,1.28-1.94,2.67-3.78,4.12-5.56.02-.04,0-.1-.04-.12-.03-.01-.06-.01-.09,0-2.13,2.07-4.02,4.38-5.62,6.89v-.24c0-.56.04-1.13.06-1.69,0-1.1-.04-2.21,0-3.31-.01-.03-.04-.04-.07-.03-.01,0-.03.02-.03.03-.05,1.09-.17,2.18-.24,3.25,0,.55-.06,1.09-.07,1.59v.95c-.5.79-.98,1.59-1.44,2.38-.81,1.48-1.54,3-2.18,4.56,0-.56-.06-1.13-.09-1.68-.07-1.25-.22-2.48-.28-3.72-.01-.03-.04-.04-.07-.03-.01,0-.03.02-.03.03v3.72c0,.62,0,1.24.08,1.86,0,.22,0,.45.04.69-.78,2.02-1.39,4.1-1.83,6.22-.42,2.26-.72,4.54-.9,6.83h0c.26-2.06.69-4.1,1.29-6.1.3-1.06.62-2.13.96-3.18,1.02-.48,1.98-1.07,2.96-1.59l3.05-1.67c2.03-1.12,4.06-2.25,6.14-3.23.06,0,0-.12-.05-.09-2.12.96-4.26,1.87-6.35,2.92-1.03.52-2.06,1.07-3.06,1.64-.84.48-1.71.95-2.52,1.5.24-.71.48-1.41.75-2.1.74-1.89,1.57-3.73,2.5-5.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m161.64,336.53s0-.06-.03-.07c-.03-.01-.06,0-.07.03,0,.01,0,.03,0,.04.09,1.29.13,2.58.27,3.87,0,.07.12.07.11,0-.05-1.29-.18-2.58-.28-3.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m173.3,340.85c-1.52.61-3.06,1.19-4.57,1.83-.05,0,0,.09,0,.07,1.54-.57,3.06-1.2,4.58-1.8.08,0,.05-.12,0-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m175.61,330.41c-1.49.68-2.93,1.46-4.33,2.32-.03.02-.04.06-.02.09.02.03.06.04.09.02h0c1.41-.79,2.84-1.59,4.3-2.38.06.02,0-.07-.05-.05Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 140.18,
    y: 403.46,
    width: 35.06,
    height: 36.96
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 137.77,
    y: 416.54,
    width: 1.79,
    height: 63.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 175.67,
    y: 416.54,
    width: 1.79,
    height: 63.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 157.67,
    y: 416.54,
    width: 1.79,
    height: 63.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 138.67,
    y: 438.05,
    width: 37.9,
    height: 5.12
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Balloons--inject-3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 308.16,
    y: 313.2,
    width: 0.72,
    height: 76.27,
    transform: "translate(-36.7 35.99) rotate(-6.3)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "279.58 285.91 311.85 389.32 311.12 389.41 278.9 286.12 279.58 285.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "312.84 387.14 304.58 256.2 305.3 256.15 313.68 389.12 312.97 389.2 312.84 387.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m279.16,222.8c-.69-18.04,16.62-20.73,19.79-21.08.99-.11,1.99-.16,2.99-.15,1.74,0,3.48.16,5.2.48,6.14,1.2,13.68,4.91,15.69,15.96,3.97,21.54-17.37,35.01-17.12,36.18.35,1.67,2.28,4.04,2.21,4.62s-1.38,1.29-2.54,1.42-2.59-.29-2.79-.83,1.17-3.28,1.15-4.99c0-.6-5.91-2.99-11.92-7.96-4.44-3.51-7.98-8.03-10.34-13.17-1.42-3.31-2.21-6.87-2.32-10.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m291.85,246.41c10.21,2.04,22.58-3.35,25.46-17.22,3.12-15.03-4.38-23.21-10.18-27.15,6.14,1.2,13.68,4.91,15.7,15.96,3.97,21.54-17.37,35.01-17.12,36.18.35,1.67,2.28,4.04,2.21,4.62s-1.38,1.29-2.54,1.42-2.59-.29-2.79-.83,1.17-3.28,1.15-4.99c0-.6-5.91-3-11.89-7.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m289.54,210.17s0,0,0,0c2.72-.29,5.16,1.67,5.45,4.38.29,2.72-1.67,5.16-4.38,5.45-2.72.29-5.16-1.67-5.45-4.38-.29-2.71,1.66-5.15,4.37-5.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m253.28,251.19c-.7-18.04,16.61-20.73,19.78-21.08.99-.11,2-.16,3-.15,1.74,0,3.48.16,5.19.48,6.17,1.15,13.71,4.89,15.74,15.93,3.96,21.54-17.38,35.01-17.12,36.18.35,1.67,2.28,4.04,2.21,4.62s-1.4,1.29-2.55,1.42-2.58-.29-2.78-.83,1.17-3.28,1.14-4.99c0-.6-5.9-2.99-11.91-7.96-4.44-3.51-7.98-8.03-10.34-13.17-1.44-3.3-2.23-6.84-2.35-10.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m265.97,274.8c10.2,2,22.54-3.34,25.46-17.22,3.11-15.02-4.39-23.21-10.19-27.15,6.17,1.15,13.71,4.89,15.74,15.93,3.96,21.54-17.38,35.01-17.12,36.18.35,1.67,2.28,4.04,2.21,4.62s-1.4,1.29-2.55,1.42-2.58-.29-2.78-.83,1.17-3.28,1.14-4.99c0-.6-5.9-3-11.91-7.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m258.65,244.11c-.3-2.71,1.65-5.15,4.36-5.45,0,0,0,0,0,0,2.71-.3,5.16,1.66,5.46,4.37s-1.66,5.16-4.37,5.46-5.16-1.66-5.46-4.37c0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m278.36,278.5c-.69-18.04,16.61-20.74,19.79-21.09.96-.1,1.92-.15,2.88-.15,1.74,0,3.48.15,5.19.46,6.16,1.12,13.8,4.83,15.84,15.96,3.96,21.54-17.38,35.01-17.12,36.18.34,1.66,2.27,4.04,2.2,4.62s-1.38,1.29-2.54,1.42-2.55-.3-2.79-.84,1.17-3.29,1.15-4.99c0-.56-5.82-2.95-11.74-7.82-4.5-3.53-8.09-8.07-10.49-13.26-1.44-3.32-2.25-6.88-2.38-10.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m304.94,309.87c.34,1.66,2.27,4.04,2.2,4.62s-1.38,1.29-2.54,1.42-2.55-.3-2.79-.84,1.17-3.29,1.15-4.99c0-.56-5.82-2.95-11.71-7.82,10.19,1.99,22.51-3.41,25.37-17.24,3.13-15.21-4.59-23.42-10.41-27.3,6.16,1.12,13.8,4.83,15.84,15.96,3.96,21.54-17.38,35.01-17.12,36.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m284.32,271.21c-.3-2.71,1.66-5.16,4.37-5.46s5.16,1.66,5.46,4.37-1.66,5.16-4.37,5.46-5.16-1.66-5.46-4.37h0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 304.54,
    y: 371.63,
    width: 13.59,
    height: 17.76,
    transform: "translate(-39.89 36.48) rotate(-6.3)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "328.28 307.33 355.69 319.93 338.55 405.37 308.61 405.37 328.28 307.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "242.58 307.33 328.28 307.33 308.61 405.37 222.91 405.37 242.58 307.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "200.89 359.53 232.11 359.53 213.43 453.68 200.89 453.68 200.89 359.53"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 298.77,
    y: 359.53,
    width: 25.22,
    height: 94.15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 175.68,
    y: 359.53,
    width: 25.22,
    height: 94.15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 200.89,
    y: 405.37,
    width: 97.88,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 200.89,
    y: 384.47,
    width: 97.88,
    height: 21.08
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m308.35,359.69l-9.52.11.26-.26.1,11.01v11.02c0,7.35.02,14.69,0,22.04s-.03,14.68-.11,22.03c-.05,7.34-.15,14.69-.29,22.04-.15-7.35-.18-14.69-.3-22.04-.11-7.35-.06-14.68-.11-22.03-.05-7.35,0-14.69,0-22.04v-11.02s.1-11.01.1-11.01v-.27h.31s9.52.11,9.52.11l9.52.16-9.47.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m201.23,381.69l.11,22.12-.11,22.07-.12,11.06-.21,11.07-.22-11.07-.12-11.06-.1-22.12.11-22.12c.07-7.37.15-14.75.33-22.12.18,7.37.26,14.75.33,22.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m225.37,405.03l24.46-.11,24.52.1,12.26.12,12.26.22-12.26.21-12.26.12-24.52.11-24.46-.11c-8.16-.07-16.32-.15-24.47-.33,8.15-.18,16.31-.26,24.47-.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m225.37,384.14l24.46-.11,24.52.11,12.26.12,12.26.21-12.26.22-12.26.12-24.52.1-24.46-.1c-8.16-.07-16.32-.16-24.47-.34,8.15-.18,16.31-.26,24.47-.33Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "316.77 453.68 316.15 461.31 314.7 478.93 308.06 478.93 306.61 461.31 305.98 453.68 316.77 453.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "316.15 461.31 306.61 461.31 305.98 453.68 316.77 453.68 316.15 461.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "239.74 453.68 239.11 461.31 237.66 478.93 231.01 478.93 229.57 461.31 228.95 453.68 239.74 453.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "239.11 461.31 229.57 461.31 228.95 453.68 239.74 453.68 239.11 461.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "193.28 453.68 192.65 461.31 191.2 478.93 184.56 478.93 183.11 461.31 182.49 453.68 193.28 453.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "193.28 453.68 192.65 461.31 183.11 461.31 182.49 453.68 193.28 453.68"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m130.84,51.02c.23-1.05,1.27-1.72,2.33-1.48,1.05.23,1.72,1.27,1.48,2.33-.22,1-1.18,1.66-2.2,1.51-1.07-.16-1.8-1.15-1.64-2.22,0-.04.01-.09.02-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m268.81,58.49c.4-2.12,2.44-3.51,4.56-3.11,2.11.4,3.5,2.43,3.11,4.55-.39,2.12-2.43,3.52-4.55,3.12-2.12-.39-3.52-2.43-3.12-4.55,0,0,0,0,0-.01Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "-14.32 48.35 13.5 19.66 -14.12 8.38 -14.32 48.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "45.18 69.72 70.12 38.52 41.55 29.92 45.18 69.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "107.12 84.82 128.43 51.02 99.07 45.68 107.12 84.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "170.57 92.51 187.65 56.4 157.87 54.62 170.57 92.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "235.62 90.84 246.94 52.53 217.25 55.37 235.62 90.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "300.42 78.2 303.97 38.4 275.41 47.03 300.42 78.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "13.47 19.9 13.63 23.92 13.74 26.6 13.86 29.98 13.96 32.65 14.1 36.03 14.19 38.72 14.34 42.08 14.45 44.76 14.57 48.14 14.68 50.83 14.81 54.21 14.92 56.89 15.03 59.82 16.99 57.63 18.76 55.62 21.01 53.1 22.78 51.09 25.03 48.55 26.82 46.54 29.05 44.01 30.84 42 33.07 39.48 34.86 37.47 37.09 34.95 38.88 32.94 41.55 29.94 13.47 19.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.63 23.92 13.74 26.6 37.09 34.95 38.88 32.94 13.63 23.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.86 29.98 13.96 32.65 33.07 39.48 34.86 37.47 13.86 29.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "14.1 36.03 14.19 38.72 29.05 44.01 30.84 42 14.1 36.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "14.34 42.08 14.45 44.76 25.03 48.55 26.82 46.54 14.34 42.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "14.57 48.14 14.68 50.83 21.01 53.1 22.78 51.09 14.57 48.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "14.81 54.21 14.92 56.89 16.99 57.63 18.76 55.62 14.81 54.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "70.1 38.62 70.68 42.59 71.07 45.26 71.54 48.59 71.91 51.26 72.4 54.59 72.77 57.25 73.26 60.6 73.64 63.25 74.13 66.59 74.5 69.26 74.99 72.59 75.36 75.26 75.79 78.15 77.49 75.77 79.07 73.59 81.03 70.85 82.61 68.67 84.56 65.92 86.13 63.73 88.1 61 89.67 58.81 91.63 56.08 93.19 53.88 95.16 51.15 96.73 48.96 99.07 45.7 70.1 38.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "70.68 42.59 71.07 45.26 95.16 51.15 96.73 48.96 70.68 42.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "71.54 48.59 71.91 51.26 91.63 56.08 93.19 53.88 71.54 48.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "72.4 54.59 72.77 57.25 88.1 61 89.67 58.81 72.4 54.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "73.26 60.6 73.64 63.25 84.56 65.92 86.13 63.73 73.26 60.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "74.13 66.59 74.5 69.26 81.03 70.85 82.61 68.67 74.13 66.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "74.99 72.59 75.36 75.26 77.49 75.77 79.07 73.59 74.99 72.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "128.25 50.85 129.28 54.75 129.97 57.35 130.83 60.61 131.51 63.21 132.39 66.47 133.07 69.07 133.93 72.32 134.62 74.91 135.49 78.19 136.16 80.79 137.02 84.05 137.72 86.65 138.47 89.48 139.89 86.91 141.19 84.56 142.84 81.61 144.13 79.26 145.78 76.31 147.07 73.96 148.72 71 150.03 68.66 151.66 65.7 152.96 63.35 154.6 60.42 155.9 58.05 157.84 54.54 128.25 50.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "129.28 54.75 129.97 57.35 154.6 60.42 155.9 58.05 129.28 54.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "130.83 60.61 131.51 63.21 151.66 65.7 152.96 63.35 130.83 60.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "132.39 66.47 133.07 69.07 148.72 71 150.03 68.66 132.39 66.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "133.93 72.32 134.62 74.91 145.78 76.31 147.07 73.96 133.93 72.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "135.49 78.19 136.16 80.79 142.84 81.61 144.13 79.26 135.49 78.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "187.69 56.07 189.25 59.79 190.3 62.27 191.62 65.37 192.66 67.84 193.98 70.96 195.01 73.44 196.31 76.54 197.37 79.01 198.68 82.13 199.72 84.61 201.02 87.71 202.08 90.19 203.21 92.89 204.26 90.15 205.23 87.64 206.44 84.49 207.41 81.99 208.6 78.82 209.57 76.32 210.78 73.17 211.73 70.66 212.94 67.51 213.91 65 215.11 61.85 216.08 59.33 217.51 55.59 187.69 56.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "189.25 59.79 190.3 62.27 215.11 61.85 216.08 59.33 189.25 59.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "191.62 65.37 192.66 67.84 212.94 67.51 213.91 65 191.62 65.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "193.98 70.96 195.01 73.44 210.78 73.17 211.73 70.66 193.98 70.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "196.31 76.54 197.37 79.01 208.6 78.82 209.57 76.32 196.31 76.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "198.68 82.13 199.72 84.61 206.44 84.49 207.41 81.99 198.68 82.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "246.68 52.7 248.87 56.07 250.35 58.34 252.18 61.15 253.65 63.41 255.48 66.24 256.95 68.49 258.78 71.32 260.27 73.56 262.12 76.4 263.56 78.66 265.41 81.47 266.88 83.73 268.47 86.19 269.03 83.3 269.52 80.66 270.16 77.34 270.66 74.71 271.3 71.39 271.79 68.75 272.42 65.43 272.93 62.8 273.54 59.48 274.05 56.84 274.69 53.52 275.18 50.89 275.93 46.93 246.68 52.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "248.87 56.07 250.35 58.34 274.69 53.52 275.18 50.89 248.87 56.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "252.18 61.15 253.65 63.41 273.54 59.48 274.05 56.84 252.18 61.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "255.48 66.24 256.95 68.49 272.42 65.43 272.93 62.8 255.48 66.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "258.78 71.32 260.27 73.56 271.3 71.39 271.79 68.75 258.78 71.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "262.12 76.4 263.56 78.66 270.16 77.34 270.66 74.71 262.12 76.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "265.41 81.47 266.88 83.73 269.03 83.3 269.52 80.66 265.41 81.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "303.32 38.24 306.12 41.11 308.02 43.03 310.37 45.44 312.25 47.36 314.61 49.76 316.5 51.68 318.85 54.09 320.73 56.01 323.11 58.42 324.97 60.34 327.35 62.76 329.23 64.68 331.28 66.76 331.25 63.84 331.22 61.15 331.18 57.78 331.16 55.08 331.12 51.71 331.1 49.03 331.06 45.65 331.03 42.95 331 39.58 330.97 36.9 330.93 33.52 330.91 30.84 330.87 26.81 303.32 38.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "306.12 41.11 308.02 43.03 330.93 33.52 330.91 30.84 306.12 41.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "310.37 45.44 312.25 47.36 331 39.58 330.97 36.9 310.37 45.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "314.61 49.76 316.5 51.68 331.06 45.65 331.03 42.95 314.61 49.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "318.85 54.09 320.73 56.01 331.12 51.71 331.1 49.03 318.85 54.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m26.94,23.86c15.82,5.44,31.82,10.19,48.01,14.27,32.34,8.35,65.42,13.54,98.76,15.5,16.64.89,33.32.76,49.94-.37,16.53-1.28,32.94-3.77,49.1-7.44l12.13-3.03c4-1.11,7.95-2.45,11.94-3.68,1.97-.63,3.99-1.2,5.93-1.92l5.85-2.24,5.83-2.25,2.91-1.12c.97-.38,1.9-.86,2.85-1.28l11.39-5.18c2-.81,3.79-1.87,5.57-2.84l5.51-2.98,5.52-2.98c1.79-1.03,3.58-2.22,5.37-3.3l10.62-6.68-10.35,7.11c-1.74,1.17-3.44,2.4-5.22,3.48l-5.36,3.16-5.36,3.16c-1.79,1.15-3.65,2.2-5.55,3.15l-11.21,5.49c-1.87,1.04-3.81,1.76-5.76,2.55l-5.84,2.36-5.84,2.38c-1.94.77-3.97,1.35-5.96,2.06-3.98,1.3-7.93,2.73-11.96,3.94l-12.18,3.27-3.04.82-3.09.56-6.18,1.39-6.17,1.27c-2.06.39-4.15.64-6.23.97-4.16.5-8.32,1.3-12.48,1.77l-12.55,1.23c-16.76,1.26-33.58,1.49-50.37.68-16.76-1.04-33.46-2.95-50.02-5.72-16.57-2.71-32.98-6.29-49.17-10.74C41.88,32.04,10.37,20.31-19.77,5.61-4.52,12.49,11.16,18.46,26.94,23.86Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "-13.46 108.93 16.44 110.03 .12 146.64 -13.46 108.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "46.41 110.04 76.28 108.27 63.53 146.27 46.41 110.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "106.04 105.06 135.53 99.96 127.11 139.16 106.04 105.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "164.5 93.2 193.17 84.61 189.52 124.53 164.5 93.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "220.7 73.44 247.69 60.54 250.23 100.53 220.7 73.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "272.62 45.54 296.56 27.57 306.92 66.29 272.62 45.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "318.25 6.76 337.29 -16.33 356.46 18.86 318.25 6.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "46.41 110.04 44.94 113.79 43.94 116.31 42.71 119.46 41.71 121.96 40.48 125.11 39.49 127.63 38.25 130.76 37.27 133.28 36.03 136.43 35.04 138.95 33.81 142.08 32.82 144.6 31.73 147.33 30.62 144.62 29.59 142.13 28.31 138.99 27.28 136.5 25.99 133.37 24.96 130.86 23.68 127.74 22.67 125.25 21.36 122.12 20.35 119.63 19.06 116.49 18.01 113.99 16.5 110.27 46.41 110.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "44.94 113.79 43.94 116.31 19.06 116.49 18.01 113.99 44.94 113.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "42.71 119.46 41.71 121.96 21.36 122.12 20.35 119.63 42.71 119.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "40.48 125.11 39.49 127.63 23.68 127.74 22.67 125.25 40.48 125.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "38.25 130.76 37.27 133.28 25.99 133.37 24.96 130.86 38.25 130.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "36.03 136.43 35.04 138.95 28.31 138.99 27.28 136.5 36.03 136.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "33.81 142.08 32.82 144.6 30.62 144.62 29.59 142.13 33.81 142.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "106.04 105.06 104.96 108.94 104.23 111.55 103.33 114.81 102.61 117.4 101.69 120.66 100.98 123.27 100.07 126.51 99.34 129.12 98.44 132.38 97.71 134.99 96.81 138.23 96.08 140.84 95.3 143.68 93.9 141.07 92.62 138.71 91.01 135.72 89.74 133.35 88.14 130.37 86.85 127.99 85.25 125.02 83.98 122.63 82.38 119.65 81.1 117.28 79.49 114.3 78.21 111.94 76.31 108.37 106.04 105.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "104.96 108.94 104.23 111.55 79.49 114.3 78.21 111.94 104.96 108.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "103.33 114.81 102.61 117.4 82.38 119.65 81.1 117.28 103.33 114.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "101.69 120.66 100.98 123.27 85.25 125.02 83.98 122.63 101.69 120.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "100.07 126.51 99.34 129.12 88.14 130.37 86.85 127.99 100.07 126.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "98.44 132.38 97.71 134.99 91.01 135.72 89.74 133.35 98.44 132.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "164.47 93.13 163.83 97.11 163.42 99.78 162.9 103.12 162.47 105.8 161.95 109.14 161.54 111.81 161.01 115.15 160.58 117.8 160.07 121.16 159.65 123.81 159.13 127.15 158.7 129.83 158.25 132.74 156.56 130.32 155.01 128.11 153.08 125.34 151.54 123.13 149.59 120.34 148.05 118.13 146.12 115.36 144.57 113.15 142.63 110.38 141.1 108.17 139.16 105.39 137.61 103.18 135.31 99.88 164.47 93.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "163.83 97.11 163.42 99.78 139.16 105.39 137.61 103.18 163.83 97.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "162.9 103.12 162.47 105.8 142.63 110.38 141.1 108.17 162.9 103.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "161.95 109.14 161.54 111.81 146.12 115.36 144.57 113.15 161.95 109.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "161.01 115.15 160.58 117.8 149.59 120.34 148.05 118.13 161.01 115.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "221.04 73.55 220.96 77.58 220.92 80.29 220.88 83.67 220.83 86.37 220.79 89.75 220.74 92.45 220.69 95.82 220.65 98.52 220.61 101.92 220.56 104.61 220.52 107.99 220.47 110.69 220.42 113.64 218.4 111.48 216.58 109.51 214.27 107.03 212.44 105.06 210.12 102.57 208.28 100.6 205.97 98.12 204.15 96.15 201.83 93.68 200.01 91.7 197.7 89.23 195.85 87.26 193.11 84.3 221.04 73.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "220.96 77.58 220.92 80.29 197.7 89.23 195.85 87.26 220.96 77.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "220.88 83.67 220.83 86.37 201.83 93.68 200.01 91.7 220.88 83.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "220.79 89.75 220.74 92.45 205.97 98.12 204.15 96.15 220.79 89.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "220.69 95.82 220.65 98.52 210.12 102.57 208.28 100.6 220.69 95.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "220.61 101.92 220.56 104.61 214.27 107.03 212.44 105.06 220.61 101.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "273.09 45.27 273.74 49.25 274.18 51.91 274.73 55.24 275.16 57.9 275.72 61.25 276.14 63.91 276.69 67.24 277.14 69.9 277.69 73.25 278.12 75.91 278.68 79.26 279.11 81.92 279.58 84.82 277.24 83.05 275.08 81.43 272.36 79.41 270.22 77.78 267.5 75.76 265.34 74.14 262.63 72.13 260.49 70.5 257.77 68.48 255.61 66.86 252.89 64.83 250.73 63.21 247.51 60.8 273.09 45.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "273.74 49.25 274.18 51.91 252.89 64.83 250.73 63.21 273.74 49.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "274.73 55.24 275.16 57.9 257.77 68.48 255.61 66.86 274.73 55.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "275.72 61.25 276.14 63.91 262.63 72.13 260.49 70.5 275.72 61.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "276.69 67.24 277.14 69.9 267.5 75.76 265.34 74.14 276.69 67.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "277.69 73.25 278.12 75.91 272.36 79.41 270.22 77.78 277.69 73.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "278.68 79.26 279.11 81.92 277.24 83.05 275.08 81.43 278.68 79.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "318.34 6.95 319.76 10.73 320.72 13.26 321.91 16.42 322.87 18.94 324.06 22.1 325.01 24.63 326.21 27.79 327.16 30.32 328.37 33.49 329.31 36 330.52 39.18 331.46 41.69 332.51 44.44 329.85 43.18 327.42 42.03 324.35 40.58 321.93 39.4 318.87 37.95 316.43 36.8 313.38 35.34 310.95 34.17 307.88 32.72 305.46 31.56 302.4 30.11 299.97 28.95 296.32 27.2 318.34 6.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "319.76 10.73 320.72 13.26 302.4 30.11 299.97 28.95 319.76 10.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "321.91 16.42 322.87 18.94 307.88 32.72 305.46 31.56 321.91 16.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "324.06 22.1 325.01 24.63 313.38 35.34 310.95 34.17 324.06 22.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "326.21 27.79 327.16 30.32 318.87 37.95 316.43 36.8 326.21 27.79"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m-19.77,108.28c16.74,1.22,33.52,1.44,50.31,1.14,16.79-.3,33.51-1.47,50.18-3.16,33.33-3.25,66.27-9.73,98.34-19.35,16.01-4.91,31.7-10.8,46.98-17.63,15.18-6.93,29.83-14.96,43.84-24.02l10.39-7.04c3.39-2.43,6.64-5.05,9.98-7.57,1.65-1.29,3.35-2.51,4.93-3.87l4.72-4.12,4.74-4.12,2.48-2.03c.79-.69,1.5-1.47,2.24-2.18l8.95-8.81c1.54-1.44,2.87-3.04,4.25-4.61l4.15-4.67,4.15-4.67c1.38-1.58,2.57-3.31,3.88-4.95l7.71-9.95-7.3,10.15c-1.26,1.69-2.41,3.46-3.73,5.1l-4.1,4.85-4.1,4.87c-1.36,1.63-2.71,3.31-4.12,4.77l-8.66,9.11c-1.44,1.54-2.97,3-4.56,4.38l-4.67,4.25-4.69,4.24c-1.57,1.4-3.26,2.65-4.9,3.99-3.3,2.65-6.54,5.3-9.91,7.84l-10.34,7.27-2.58,1.82-2.69,1.67-5.36,3.34-5.39,3.33c-1.79,1.08-3.67,2.04-5.52,3.06-3.72,1.98-7.38,4.1-11.15,5.98l-11.4,5.48c-15.35,6.96-31.12,12.98-47.21,18.01-16.15,4.8-32.54,8.76-49.1,11.88-16.54,3.15-33.23,5.43-50.01,6.83-33.52,3.06-67.25,2.86-100.73-.61Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Balloons--inject-3-2",
    "data-name": "freepik--Balloons--inject-3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: -43.55,
    y: 216.92,
    width: 84.97,
    height: 0.8,
    transform: "translate(-214.74 177.69) rotate(-79.77)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "36.83 147.1 -6.85 259.45 -7.66 259.3 36.09 146.8 36.83 147.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "-8.9 259.08 -9.68 258.94 9.77 111.77 10.56 111.88 -8.59 256.8 -8.9 259.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m37.99,88.15c-3.01,5.54-7.29,10.29-12.49,13.86-7.06,5.06-13.8,7.27-13.85,7.94-.15,1.9,1.15,5.05.9,5.63s-1.88.94-3.16.71-2.68-1.12-2.71-1.77,2.29-3.14,2.81-4.97c.36-1.29-22.33-17.89-16.28-41.52,3.08-12.13,11.74-15.68,18.66-16.55,1.93-.23,3.88-.27,5.81-.13,1.11.07,2.21.2,3.31.4,3.5.63,22.53,4.94,20.39,24.94-.4,4-1.54,7.89-3.38,11.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m11.63,109.94c-.15,1.9,1.15,5.05.9,5.63s-1.88.94-3.16.71-2.68-1.12-2.71-1.77,2.29-3.14,2.81-4.97c.36-1.29-22.33-17.89-16.28-41.52,3.09-12.13,11.75-15.68,18.67-16.54-6.74,3.94-15.71,12.46-13.38,29.4,2.14,15.64,15.48,22.57,26.99,21.08-7.03,5.09-13.77,7.31-13.83,7.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m35.24,68.25c-.53,3-3.4,4.99-6.39,4.46-3-.53-4.99-3.4-4.46-6.39.53-3,3.4-4.99,6.39-4.46,0,0,0,0,.01,0,2.99.54,4.98,3.4,4.45,6.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m64.56,121.64c-3.01,5.54-7.29,10.29-12.49,13.86-7.06,5.06-13.79,7.27-13.84,7.94-.16,1.89,1.14,5.04.89,5.63s-1.88.94-3.15.71-2.69-1.12-2.72-1.77,2.29-3.14,2.81-4.97c.37-1.29-22.32-17.88-16.28-41.52,3.09-12.12,11.76-15.7,18.71-16.51,1.93-.23,3.87-.27,5.8-.14,1.11.07,2.22.2,3.32.4,3.5.63,22.53,4.94,20.38,24.94-.41,3.99-1.57,7.87-3.41,11.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m38.22,143.44c-.16,1.89,1.14,5.04.89,5.63s-1.88.94-3.15.71-2.69-1.12-2.72-1.77,2.29-3.14,2.81-4.97c.37-1.29-22.32-17.88-16.28-41.52,3.09-12.12,11.76-15.7,18.71-16.51-6.74,3.94-15.71,12.46-13.4,29.4,2.18,15.65,15.5,22.53,26.99,21.08-7.06,5.05-13.79,7.27-13.84,7.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m62.54,101.95c-.54,2.99-3.41,4.98-6.4,4.44s-4.98-3.41-4.44-6.4c.54-2.99,3.41-4.98,6.4-4.44,0,0,0,0,.01,0,2.99.54,4.97,3.4,4.44,6.39,0,0,0,0,0,.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m34.57,150.15c-3.06,5.58-7.4,10.36-12.67,13.94-6.96,4.96-13.6,7.17-13.65,7.8-.15,1.88,1.2,5.05.9,5.63s-1.88.95-3.16.72-2.68-1.12-2.71-1.77,2.29-3.15,2.8-4.97c.37-1.29-22.32-17.88-16.28-41.52,3.12-12.22,11.9-15.76,18.83-16.54,1.93-.21,3.87-.25,5.81-.11,1.07.07,2.14.2,3.19.39,3.5.63,22.53,4.95,20.39,24.95-.42,4.01-1.59,7.91-3.44,11.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m-10.2,129.97c3.12-12.22,11.9-15.76,18.83-16.54-6.77,3.87-15.97,12.4-13.66,29.55,2.13,15.6,15.41,22.53,26.89,21.1-6.92,4.96-13.56,7.18-13.61,7.8-.15,1.88,1.2,5.05.9,5.63s-1.88.95-3.16.72-2.68-1.12-2.71-1.77,2.29-3.15,2.8-4.97c.37-1.3-22.31-17.9-16.28-41.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m31.94,130.1c-.54,2.99-3.41,4.98-6.4,4.44s-4.98-3.41-4.44-6.4,3.41-4.98,6.4-4.44,4.98,3.41,4.44,6.4h0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: -16.31,
    y: 241.97,
    width: 19.79,
    height: 15.15,
    transform: "translate(-250.86 198.93) rotate(-79.77)"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeNoahBirthday);
export default __webpack_public_path__ + "static/media/home-noah-birthday.dc014151a40780c7b0c22fd6069c64bb.svg";
export { ForwardRef as ReactComponent };